var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.deviceClass,attrs:{"id":"app"}},[(_vm.isBrowserIE)?_c('div',{staticClass:"not-supported",domProps:{"innerHTML":_vm._s(_vm.t('ie_not_supported'))}}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }